import { map, Observable } from 'rxjs';
import { MetadataHistoryComponent } from '../components';
import {
  MetaControlsHistoryData,
  MetaControlsHistoryItem,
} from '../utils/meta-controls';
import { QtControlAdapter } from './qt-control-adapter';

export class HistoryAdapter
  implements QtControlAdapter<MetaControlsHistoryData>
{
  readonly key = 'history';

  /** MetaControls subscribes to apply a history snapshot to all adapters. */
  readonly applyHistory$: Observable<MetaControlsHistoryItem> =
    this.component.applyHistoryToMetaControls;

  /** MetaControls subscribes to collect snapshot from all adapters and save. */
  readonly saveSnapshot$: Observable<{ name: string; type: string }> =
    this.component.saveCurrentStateToHistory;

  /** MetaControls subscribes to remove an item. */
  readonly deleteItem$: Observable<MetaControlsHistoryItem> =
    this.component.deleteHistoryItem;

  readonly valueChanges$: Observable<MetaControlsHistoryData> =
    this.component.valueChanges$.pipe(map(items => this._toStructure(items)));

  constructor(readonly component: MetadataHistoryComponent) {}

  applyValue(value: MetaControlsHistoryData): void {
    const flat = [...(value?.prs ?? []), ...(value?.org ?? [])];
    this.component.setHistoryItems(flat);
  }

  getValue(): MetaControlsHistoryData {
    return this._toStructure(this.component.getCurrentHistoryItems());
  }

  addHistoryItem(item: MetaControlsHistoryItem): void {
    const current = this.component.getCurrentHistoryItems();
    this.component.setHistoryItems([item, ...current]);
  }

  removeHistoryItem(toDelete: MetaControlsHistoryItem): void {
    const current = this.component.getCurrentHistoryItems();
    this.component.setHistoryItems(
      current.filter(
        i => !(i.name === toDelete.name && i.type === toDelete.type)
      )
    );
  }

  private _toStructure(
    items: MetaControlsHistoryItem[]
  ): MetaControlsHistoryData {
    return {
      prs: items.filter(i => i.type === 'prs'),
      org: items.filter(i => i.type === 'org'),
    };
  }
}
